import type { Chart as ChartJS, ChartType, InteractionItem } from 'chart.js';
import { getElementAtEvent } from 'react-chartjs-2';
import type { MouseEvent } from 'react';

/**
 * Bridge typed chart refs to react-chartjs-2 after treemap registration widens ChartTypeRegistry.
 */
export function chartElementAtEvent<TType extends ChartType>(
  chart: ChartJS<TType>,
  event: MouseEvent<HTMLCanvasElement>
): InteractionItem[] {
  return getElementAtEvent(chart as ChartJS, event);
}
